import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type Tone = 'red' | 'blue';
interface CTABannerProps {
  eyebrow: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaHref: string;
  tone?: Tone;
}
const toneStyles: Record<Tone, {
  wrap: string;
  rule: string;
  button: string;
}> = {
  red: {
    wrap: 'border-guards/40 hover:border-guards',
    rule: 'bg-guards',
    button: 'btn-glint btn-glint-sheen btn-halo-red bg-guards text-white hover:bg-guards-bright'
  },
  blue: {
    wrap: 'border-gentian/50 hover:border-gentian-bright',
    rule: 'bg-gentian-bright',
    button: 'btn-glint btn-glint-sheen btn-halo-blue bg-gentian text-white hover:bg-gentian-bright'
  }
};

/** Banner interactivo con CTA iluminado, usado en Servicio y Financiamiento. */
export function CTABanner({
  eyebrow,
  title,
  description,
  ctaLabel,
  ctaHref,
  tone = 'red'
}: CTABannerProps) {
  const styles = toneStyles[tone];
  return <Reveal data-id="element-29" data-mp="x6f9lj8m92i4">
      <div className={`group relative flex flex-col gap-7 border bg-surface px-5 py-8 transition-colors duration-[800ms] ease-[var(--ease-lux)] sm:px-7 sm:py-9 lg:flex-row lg:items-center lg:justify-between lg:gap-8 lg:px-12 lg:py-11 ${styles.wrap}`} data-id="element-30" data-mp="x5w1svcojuht">
        <span className={`absolute left-0 top-0 h-full w-[3px] origin-top scale-y-100 ${styles.rule}`} aria-hidden="true" data-id="element-31" data-mp="nacakm929jze" />
        <div className="lg:max-w-xl" data-id="element-32" data-mp="eew7demf1sh5">
          <p className="text-[10px] uppercase tracking-[0.3em] text-mute" data-id="element-33" data-mp="edthna0txw2t">{eyebrow}</p>
          <h3 className="mt-4 text-2xl font-light tracking-[-0.02em] text-white lg:text-[32px]" data-id="element-34" data-mp="j8h83efe90k1">
            {title}
          </h3>
          <p className="mt-3 text-sm font-light leading-relaxed text-mute lg:text-base" data-id="element-35" data-mp="9gbha80vop6f">
            {description}
          </p>
        </div>
        <a href={ctaHref} className={`inline-flex w-full shrink-0 items-center justify-center gap-3 px-9 py-4 text-[13px] font-medium tracking-wide transition-colors duration-500 ease-[var(--ease-lux)] sm:w-fit ${styles.button}`} data-id="element-36" data-mp="3rnhdkg3qh0d5">
          <span data-id="element-37" data-mp="1xelxd4i7qdun">{ctaLabel}</span>
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-[800ms] ease-[var(--ease-lux)] group-hover:translate-x-1" aria-hidden="true" data-id="element-38" data-mp="1xdkcy9fb4f09" />
        </a>
      </div>
    </Reveal>;
}